import { apiClient } from './createApiClient';

export type Asset = {
  assetUrl: string;
};

// T: the asset fields a caller reads beyond assetUrl (id, name, type...)
export const uploadAsset = <T extends Asset = Asset>(
  groupId: string,
  file: File,
  assetPath: string
): Promise<T> => {
  const formData = new FormData();

  formData.append('file', file, file.name);
  formData.append('assetPath', assetPath);

  return apiClient.post<T>(`/api/${groupId}/assets`, formData, { groupId });
};
